import { render } from "./Onboarding.vue?vue&type=template&id=459e4ce8&scoped=true"
import script from "./Onboarding.vue?vue&type=script&lang=js"
export * from "./Onboarding.vue?vue&type=script&lang=js"

import "./Onboarding.vue?vue&type=style&index=0&id=459e4ce8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-459e4ce8"

export default script